var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "white",
    stroke: "#D8E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3254 27.1631H29.6298V28.1203H20.3254V27.1631Z",
    fill: "#51ACFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3254 30.3608H36.2029V31.3181H20.3254V30.3608Z",
    fill: "#51ACFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3254 20.769H28.6088V21.7263H20.3254V20.769Z",
    fill: "#51ACFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3254 23.9663H28.6088V24.9236H20.3254V23.9663Z",
    fill: "#51ACFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6739 15H31.8634C30.8615 15 30.0447 15.8168 30.0447 16.8188V17.4633H18.0472C17.2686 17.4633 16.6369 18.0951 16.6369 18.8736V28.3567L14.6905 29.799C14.5692 29.8883 14.499 30.0351 14.499 30.1819V43.3216C14.499 44.2406 15.2457 44.9936 16.171 44.9936H40.3574C41.2763 44.9936 42.0293 44.247 42.0293 43.3216V30.1946V30.1883C42.0293 30.0351 41.9591 29.8883 41.8315 29.799L39.8915 28.4014V26.7103H42.6803C43.6822 26.7103 44.499 25.8934 44.499 24.8915V16.8188C44.4926 15.8168 43.6758 15 42.6739 15ZM15.4626 43.3535C15.4626 43.3408 15.4563 43.3344 15.4563 43.3216V31.0817L22.8015 36.0147L15.4626 43.3535ZM16.6432 29.5501V30.7243L15.8136 30.1627L16.6432 29.5501ZM16.171 44.0364C16.1582 44.0364 16.1519 44.03 16.1391 44.03L23.612 36.5571L27.3006 39.0332C27.5877 39.2374 27.926 39.3331 28.2642 39.3331C28.596 39.3331 28.9279 39.231 29.215 39.0396L32.9164 36.5571L40.3893 44.03C40.3765 44.03 40.3701 44.0364 40.3574 44.0364H16.171ZM41.0657 31.0817V43.3216C41.0657 43.3344 41.0593 43.3408 41.0593 43.3535L33.7205 36.0147L41.0657 31.0817ZM40.7083 30.1691L39.8851 30.7243V29.5756L40.7083 30.1691ZM38.9279 31.3689L28.6726 38.2482C28.4301 38.4206 28.0983 38.4205 27.843 38.2419L17.6005 31.3689V18.8736C17.6005 18.6248 17.8047 18.4205 18.0536 18.4205H30.0447V24.8851C30.0447 25.887 30.8615 26.7039 31.8634 26.7039H32.4888V29.0332C32.4888 29.2183 32.5973 29.3906 32.7632 29.4671C32.827 29.499 32.8972 29.5118 32.9674 29.5118C33.0759 29.5118 33.1844 29.4735 33.2738 29.4033L36.5156 26.7103H38.9279V31.3689ZM43.5354 24.8851C43.5354 25.3638 43.1461 25.7467 42.6739 25.7467H36.3433C36.2284 25.7467 36.12 25.7849 36.037 25.8551L33.4461 28.0121V26.2253C33.4461 25.9636 33.2291 25.7467 32.9674 25.7467H31.8634C31.3848 25.7467 31.0019 25.3574 31.0019 24.8851V16.8188C31.0019 16.3401 31.3912 15.9572 31.8634 15.9572H42.6739C43.1461 15.9572 43.5354 16.3465 43.5354 16.8188V24.8851Z",
    fill: "#4D5152"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2993 22.8682H41.2317V23.8254H33.2993V22.8682Z",
    fill: "#51ACFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2993 20.4434H41.2317V21.4006H33.2993V20.4434Z",
    fill: "#51ACFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2993 18.0249H41.2317V18.9821H33.2993V18.0249Z",
    fill: "#51ACFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCost);
export default __webpack_public_path__ + "static/media/email-cost.dd160b28a4da49b036951a07ba7b1ef0.svg";
export { ForwardRef as ReactComponent };